import * as mutations from "@/store/mutation-types";

export default {
  [mutations.SET_USER](state, payload) {
    state.user = payload;
  },

  [mutations.SET_ORGANISATION](state, payload) {
    state.organisation = payload;
  },

  [mutations.SET_ORGANISATIONS](state, payload) {
    state.organisations = payload.filter(
      organisation => organisation.status_id !== 10
    );
    state.invites = payload.filter(
      organisation => organisation.status_id === 10
    );
  },

  [mutations.SET_WALLET](state, payload) {
    state.wallet = payload;
  },

  [mutations.SET_SWITCH_KEY](state, payload) {
    state.switch_key = payload;
  },

  [mutations.LOGOUT](state, defaultState) {
    Object.assign(state, { ...defaultState.auth });
  }
};
